import {Pagination} from '@deere/fuel-react';
import React from 'react';
import './Paginator.css';

const Paginator = (props) => {
  const [startIndex, setStartIndex] = React.useState(0);
  const [currentPage, setCurrentPage] = React.useState(1);
  const TOTAL_PAGES = Math.ceil(props.elementCount / props.pageSize);

  const goToPage = (pageNumber) => {
    let currIndex = (pageNumber - 1) * props.pageSize;
    props.onPageChange(currIndex);
    setStartIndex(currIndex);
    setCurrentPage(pageNumber);
  };

  React.useEffect(() => {
    props.onPageChange(startIndex);
  }, []);

  React.useEffect(() => {
    if (props.reset) {
      goToPage(1);
      props.onPaginationReset();
    }
  });
  return TOTAL_PAGES ? (
    <Pagination
      id="customPagination"
      className="customPagination"
      count={TOTAL_PAGES}
      onChange={(event, nextPage) => goToPage(nextPage)}
      page={currentPage}
    />
  ) : null;
};
export default Paginator;
